<template>
  <div>
    <el-row
        type="flex"
        v-gutter="gutter"
        align="middle"
        class="operate-group"
        :class="{'operate-group' : marginBottom}">
      <slot name="before"></slot>
      <gj-button
          v-if="log"
          plain
          @click="$emit('viewLog')"
      >操作日志</gj-button>
      <gj-tooltip
          v-if="isShowVideo"
          content="教程视频"
          style="margin-left: 6px;">
          <gj-button
              type="icon"
              plain
              class="tool--btn-icon"
              @click="previewRow"
           >
            <i class="tool--btn-icon iconfont icontv-o" ></i>
          </gj-button>
      </gj-tooltip>
      <gj-tooltip
          v-if="reset"
          content="重置">
        <gj-button
            icon="el-icon-refresh"
            type="icon"
            plain
            class="tool--btn-icon"
            @click="$emit('reset')"
        ></gj-button>
      </gj-tooltip>
      <gj-tooltip
          v-if="setting"
          content="设置自定义列">
        <gj-button
            icon="el-icon-setting"
            type="icon"
            plain
            class="tool--btn-icon"
            @click="openCustomColumnModal"
        ></gj-button>
      </gj-tooltip>
      <gj-tooltip
          v-if="task"
          content="任务进度">
        <gj-popover
            v-model="taskProgressVisible"
            :title="'任务进度'"
            trigger="manual"
            :placement="placement"
            @close="closeTask">
          <template slot="reference">
            <el-badge :value="taskTip">
              <gj-button
                  plain
                  class="tool--btn-icon"
                  style="padding: 8px 8px;"
                  @click="openTask">
                <gj-icon iconfont="iconliebiao"></gj-icon>
              </gj-button>
            </el-badge>
          </template>
          <slot name="task-content"></slot>
        </gj-popover>
      </gj-tooltip>
      <gj-tooltip
          v-if="download"
          content="导出">
        <gj-button
            icon="el-icon-download"
            type="icon"
            plain
            :loading="downloadLoading"
            class="tool--btn-icon"
            @click="clickDownload"
        ></gj-button>
      </gj-tooltip>
<!--      <el-divider-->
<!--          v-if="help && (download || setting)"-->
<!--          direction="vertical"-->
<!--          style="height: 32px;"-->
<!--      ></el-divider>-->
      <gj-tooltip
          v-if="help"
          content="帮助文档">
          <!--        <a :href="helpUrl" target="_blank">-->
          <gj-button
              @click="openHelp"
              type="icon"
              plain
              class="tool--btn-icon">
            <gj-icon iconfont="iconbangzhushouce" class="gj-help--icon"></gj-icon>
          </gj-button>
        <!--        </a>-->
      </gj-tooltip>
    </el-row>
  </div>
</template>

<script>
import {exportFile, getCustomColumns} from "../../api/common";
import {isEmptyArr, isMeaningful, isMeaningless} from "../../utils/common";
import {mapGetters} from "vuex";
import {helpUrlBase, helpUrls} from "./helpUrl"
import { getTaskTenantVideoUrl } from "@/api/guide";
import GjVideoModal from "@/components/video/gj-video-modal.vue";

export default {
  name: "gj-tool-group",
  props: {
    marginBottom:{
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      default: false
    },
    modalMountTo: {
      required: false,
    },
    setting: {
      type: Boolean,
      default: false,
    },
    log: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: false,
    },
    downloadUrl: {
      type: String,
    },
    downloadParams: {
      type: Object,
      default: () => {}
    },
    downloadValidator: {
      type: Function,
      default: null
    },
    help: {
      type: Boolean,
      default: false,
    },
    // helpUrl: {
    //   type: String,
    //   default: 'http://help.gerpgo.com/web/#/26',
    // },
    helpName: {
      type: String
    },
    task: {
      type: Boolean,
      default: false,
    },
    taskTip: {
      type: [Number, String],
      default: null
    },
    tableName: {
      type: String
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    sortGjtable:{
      required: false,
    },
    tableType:{
      type:String,
      default:null
    }
  },
  data() {
    return {
      sign:true,
      customID2:'',
      customColumns2:'',
      customID:'',
      customColumns: {
        type: Array,
        default: () => []
      },
      sortCustomColumns: [],
      columnsServer: "",
      taskProgressVisible: false,
      proxyTask: false,
      downloadLoading: false,
      gutter: 8,
      isShowVideo: false,
      showVideoUrl: null,
    }
  },
  mounted() {
    this.$nextTick(() => this.proxyTask = this.task);
  },
  computed: {
    ...mapGetters(['userResources']),
    placement() {
      return document.body.offsetHeight > 700 ? 'bottom-end' : 'left-start'
    }
  },
  watch: {
    userResources() {
      this.gutter = 7;
      this.$nextTick(() => this.gutter = 8);
    },
    tableColumns: {
      handler: function (newVal, oldVal) {
        if ((this.setting && newVal !== oldVal)) {
          this.setColumns()
        }
      },
      immediate: true
    },
  },
  created() {
      this.showVideoGuide();
  },
  activated() {
      this.showVideoGuide();
  },
  methods: {
    openHelp(){
      let path = this.$route.path.split('/');
      let name = path[path.length-1].replace(/-/g,'');
      if(this.helpName){
        window.open(helpUrlBase + helpUrls[this.helpName]);
      }else {
        window.open(helpUrlBase + helpUrls[name]);
      }
    },
    setColumns() {
      // if(!this.sign) return
      this.sign = false;

      // tableHeader
      // 1、存在header字段定义且不存在二级header（通过children字段判断，存在children则会渲染二级头）
      // 2、字段是自定义字段（通过notCustomColumn判断）
      const columns1 = this.tableColumns
        .filter(e => isMeaningless(e.children))
        .filter(e => (e.header || e.title) && !e.notCustomColumn);
      // tableRow
      const columns2 = this.tableColumns
        .filter(e => isMeaningful(e.children))
        .map(e => e.children)
        .reduce((e1, e2) => e1.concat(e2), []);
      
      this.customColumns = [...columns1, ...columns2]
        .map(e => {
          if(this.tableType === 'vxe-virtual-tree'){
            e.name = e.title
          }else{
            e.name = e.header.includes("slot") ? e.header.split(':')[2] : e.header;
          }
          return e;
          })
        .filter(e => (!e.fasten));
    
      this.customID = this.customColumns.map(m => m.id);
      if (!this.customColumns2) {
        //克隆左侧渲染专用列表
        this.customColumns2 = this._.cloneDeep(this.customColumns);
        this.customID2 = this.customColumns2.map(m => m.id)
      } else {
        //遍历同步左侧渲染专用列表 的 具体项 ， 不改变初始顺序
        this.customID2.forEach((r, index) => {
          let m = this.customID.indexOf(r);
          if (m === -1) {
            this.customID2.splice(index);
            this.customColumns2.splice(index);
          }
        })
        this.customID.forEach((r, index) => {
          let m = this.customID2.indexOf(r);
          if (m === -1) {
            this.customID2.splice(index, 0, r)
            this.customColumns2.splice(index, 0, this.customColumns[index])
          } else {
            m = r; // ??
            this.customColumns2[index] = this.customColumns[index]
          }
        })

        //遍历设置列表项是否存在
        // for(let i of this.customColumns){
        //   if(isMeaningful(i.exist)){
        //     this.customColumns2.find(m=>{return m.id === i.id}).exist = i.exist;
        //   }
        // }

        /* 商品表现页面特殊处理 */
        let columns1 = this.customColumns.find(m=>{
          return m.id==='listingInfo'
        });
        let columns2 = this.customColumns2.find(m=>{
          return m.id==='listingInfo'
        });
        if(columns1&&columns2&&columns2.name){
          columns2.name = columns1.name;
        }
      }
      this.getCustomData()
    },
    getCustomData(){
      getCustomColumns(this.tableName)
          .then(columns => Promise.resolve(isMeaningful(columns)?columns.split(','):[]))
          .then((columns) => {
            if (isEmptyArr(columns)) {
              columns = this.customColumns.filter(e => e.default).map(e => e.id);
            }
            this.columnsServer = columns;
            this.checkColumn(columns);
            setTimeout(()=>{this.sign=true},500)
          });
    },
    openCustomColumnModal() {
      // console.log('openCustomColumnModal', {
      //     name: this.tableName,
      //     columns: this.customColumns2,
      //     sortColumns:this.sortCustomColumns,
      //     columnsServer: this.columnsServer,
      //     size: 'middle'
      //   })
      const vm = this;
      this.$gjCreate('gj-setting-modal', {
        mountTo: this.modalMountTo,
        props: {
          name: this.tableName,
          columns: this.customColumns2,
          sortColumns:this.sortCustomColumns,
          columnsServer: this.columnsServer,
          size: 'middle'
        },
        on: {
          ['check-list'](columns) {
            vm.checkColumn(columns);
            vm.columnsServer = columns;
          }
        }
      });
    },
    checkColumn(columns) {
      if(this.setting){
        setTimeout(()=>{
          if(this.sortGjtable){
            let gjTable = this.findGjTable(this.sortGjtable);
            let { fullColumn} =gjTable.getTableColumn();
            let sortCol = this.sortColumn3(columns,fullColumn);
            this.sortColumn(columns);
            this.sortColumn2(columns);
            gjTable.loadColumn(sortCol);
            gjTable.updateFooter()
          }
        }, 50)
      }
      this.customColumns2.forEach(column => {
        this.$set(column, 'checked', (columns.some(e => e === column.id)));
        if (column.fasten) {
          this.$set(column, 'checked', true);
        }
      });
      this.customColumns.forEach(column => {
        this.$set(column, 'checked', (columns.some(e => e === column.id)));
        if (column.fasten) {
          this.$set(column, 'checked', true);
        }
      });
    },
    findGjTable(instance) {
      if (!instance) return;
      const tag = instance.$refs.gjTable.$options._componentTag
      if(tag === 'vxe-table' || tag === 'vxe-virtual-tree'){
        return instance.$refs.gjTable;
      }
      instance = instance.$refs.gjTable;
      return this.findGjTable(instance)
    },
    //  原始数据的排序修改
    sortColumn(columns){
      let columnsArr = this._.cloneDeep(columns)
      let oldTableColumns = this._.cloneDeep(this.tableColumns)
      for(let i = 0; i < oldTableColumns.length ; i++) {
        let item = oldTableColumns[i]
        let index = columnsArr.findIndex(column=> item.id === column);
        if(index === -1) {
          columnsArr.splice(i, 0, item.id);
        }
      }
      columnsArr.forEach((item,i)=>{
        let index = this.tableColumns.findIndex(column=> item === column.id);
        if(index !== -1){
          const val = this.tableColumns[index];
          this.tableColumns.splice(index, 1);
          this.tableColumns.splice(i, 0, val);
        }
      });
    },
    // 表头列的排序
    sortColumn2(columns){
      this.sortCustomColumns = this._.cloneDeep(this.customColumns);
      columns.forEach((item,i)=>{
        let index =  this.sortCustomColumns.findIndex(column=> item === column.id);
        if(index !== -1){
          const val = this.sortCustomColumns[index];
          this.sortCustomColumns.splice(index, 1);
          this.sortCustomColumns.splice(i, 0, val);
        }
      });
    },
    //  gjTable columns 排序
    sortColumn3(columns,sortData){
      let idMap = {};
      for(let item of this.tableColumns){
        idMap[item.id] = item.field
      }
      let indexNum = 0;
      sortData.forEach(item=>{
        if(item.title ==='序号' || item.type ==='checkbox'){
          indexNum++;
        }
      })
      columns.forEach((item,i)=>{
        let index = sortData.findIndex(column=> {
          return column.property === idMap[item]
        });
        if(index !== -1){
          const val = sortData[index];
          sortData.splice(index, 1);
          sortData.splice(i+indexNum, 0, val);
        }
      });
      // if field is 'checkbox' move to first column - 2022.03.07
      const checkboxColIndex = sortData.findIndex(it => it.type === 'checkbox')
      if (checkboxColIndex > -1) {
        const checkBoxColStash = sortData[checkboxColIndex]
        sortData.splice(checkboxColIndex, 1)
        sortData.unshift(checkBoxColStash)
      }
      return sortData;
    },
    clickDownload() {
      if (this.$listeners['clickDownload']
          || this.$listeners['click-download']
          || isMeaningless(this.downloadUrl)) {
        this.$emit('clickDownload');
      } else {
        if (isMeaningful(this.downloadValidator) && !this.downloadValidator()) {
          return;
        }
        this.downloadLoading = true;
        exportFile(this.downloadUrl, this.downloadParams)
            .complete(() => {
              this.downloadLoading = false;
            });
      }
    },
    openTask() {
      this.taskProgressVisible = true;
      this.$emit('clickTask');
    },
    closeTask() {
      this.taskProgressVisible = false;
    },
    showVideoGuide() {
      let path = this.$route.path;
       getTaskTenantVideoUrl({moduleUrl: path}).then(res => {
            if (isMeaningful(res) && res.length > 0) {
               this.isShowVideo = true;
               this.showVideoUrl = res[0].videoUrl;
            }else {
               this.isShowVideo = false;
               this.showVideoUrl = null;
            }
       })
    },
     previewRow() {
      if (this.showVideoUrl && this.showVideoUrl.length > 0) {
         this.$gjCreate(GjVideoModal , {
          props: {
              content: '教程视频',
              url: this.showVideoUrl
          },
      })

      }
     
    },

  }
}
</script>

<style lang="scss" scoped>
  .tool--btn-icon {
    font-size: 14px;
  }
  >>> .el-divider {
    height: 32px;
  }
  .operate-group {
    margin: 16px 0 12px;
  }
  .gj-help--icon {
    color: #333333;
  }
  /deep/ .el-badge {
    height: 32px;
  }
  
</style>

